type ErrorFormStatus = {
  readonly type: "error";
  readonly error: Error;
};

type SubmittingFormStatus = {
  readonly type: "success";
};

type SuccessFormStatus = {
  readonly type: "success";
};

type FormStatus = SubmittingFormStatus | ErrorFormStatus | SuccessFormStatus;

function isErrorFormStatus(obj?: any): obj is ErrorFormStatus {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  return obj.type === "error" && "error" in obj;
}

function isSuccessFormStatus(obj?: any): obj is SuccessFormStatus {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  return obj.type === "success";
}

function isFormStatus(obj?: any): obj is FormStatus {
  if (!obj) {
    return false;
  }
  if (!("type" in obj)) {
    return false;
  }
  if (isErrorFormStatus(obj)) {
    return true;
  }
  return obj.type === "success" || obj.type === "submitting";
}

export type { FormStatus };
export { isErrorFormStatus, isSuccessFormStatus, isFormStatus };
